import { MutationTree } from 'vuex'
import { FoldersState, UISharedFolderModel } from './folders.model'
import arrayToDict from '../../../utils/array-to-dictionary'

export enum MutationTypes {
  GET_FOLDERS_REQUEST = 'GET_FOLDERS_REQUEST',
  GET_FOLDERS_SUCCESS = 'GET_FOLDERS_SUCCESS',
  GET_FOLDERS_ERROR = 'GET_FOLDERS_ERROR'
}

export const mutations: MutationTree<FoldersState> = {
  [MutationTypes.GET_FOLDERS_REQUEST](state) {
    state.loading = true
  },
  [MutationTypes.GET_FOLDERS_SUCCESS](state, folders: Array<UISharedFolderModel>) {
    state.loading = false
    const dict = arrayToDict(folders, 'companyId')
    state.folders = {
      ...state.folders,
      ...dict
    }
  },
  [MutationTypes.GET_FOLDERS_ERROR](state, error) {
    state.errorMessage = error.message
    state.loading = false
    state.folders = {}
  }
}
